import React from "react";
import { motion } from "framer-motion";
import { FaChalkboardTeacher, FaFileSignature, FaWallet } from "react-icons/fa";

const cards = [
  {
    icon: <FaChalkboardTeacher size={24} className="text-green-600" />,
    title: "Expert Guidance That Makes Sense",
    description:
      "Not sure where to begin? Our expert advisors make the process simple by breaking down your loan options in clear, easy-to-understand terms. We listen to your needs, offer personalized recommendations, and guide you from start to finish with no confusion, no pressure. Whether it's your first loan or your fifth, we’re here to help you make confident, informed decisions every step of the way.",
    button: "Learn more",
  },
  {
    icon: <FaFileSignature size={24} className="text-green-600" />,
    title: "Simple Documentation, Fast Approval",
    description:
      "Forget the old-school paperwork hassle. Our process is built for speed with a simple, minimal documentation system that saves you time and energy. We guide you on exactly what’s needed, help with every step, and ensure your application moves fast. No confusion, no delays, just smooth approvals, stress-free.",
    button: "Learn more",
  },
  {
    icon: <FaWallet size={24} className="text-green-600" />,
    title: "EMIs That Work With Your Budget",
    description:
      "Worried about monthly payments? Don’t be. We offer flexible EMI plans that align with your income and lifestyle so your loan never feels like a burden. Our team helps you choose the right tenure and amount to keep your finances balanced. Easy, affordable, and stress-free repayments every month.",
    button: "Learn more",
  },
];


const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const WhyChoose = () => {
  return (
<div className="container mx-auto px-4" id="why-choose-us">
      <section className="rounded-xl bg-gradient-to-b from-white via-[#f0faff] to-[#d6f0ff] py-16 px-4 mb-8 ">
        <div className="max-w-6xl mx-auto text-center mb-12">
          <p className="text-green-600 font-semibold tracking-wide mb-2">
            EASY, SIMPLE, FREE
          </p>
          <h4 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose <br className="hidden md:block" />
            for Your Personal Loans Needs?
          </h4>
          <p className="text-gray-600">
            Loans made simple, approvals made fast.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-6 max-w-6xl mx-auto">
          {cards.map((card, i) => (
            <motion.div
              key={i}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={cardVariants}
              className="relative bg-white rounded-xl border shadow-md p-6 pt-12 text-left hover:shadow-xl transition-shadow duration-300"
            >
              {/* Icon on top */}
              <div className="absolute -top-6 left-10 bg-blue-900 p-3 rounded-md shadow-xl">
                {card.icon}
              </div>

              <h5 className="font-semibold text-lg text-gray-900 mb-4">
                {card.title}
              </h5>
              <p className="text-gray-600 mb-2">{card.description}</p>
              {/* <button
                className={`${
                  i === 0
                    ? "bg-blue-900 text-white"
                    : "border border-blue-900 text-blue-900"
                } px-5 py-2 rounded-md text-sm font-medium transition-colors duration-300 hover:bg-blue-900 hover:text-white`}
              >
                {card.button}
              </button> */}
            </motion.div>
          ))}
        </div>
      </section>
    </div>
    
  );
};

export default WhyChoose;
